import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    transform: 'translateY(40px)',
    opacity: 0,
    transition: 'all ease 0.5s',
    '&.active': {
      transform: 'translateY(0px)',
      opacity: 1,
      transition: 'all ease 0.5s',
    },
    [theme.breakpoints.down(1281)]: {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '@media (max-height: 799px)': {
      display: 'none',
    },
  },
  stepNumber: {
    minWidth: 32,
    minHeight: 32,
    width: 32,
    height: 32,
    border: `1px solid ${theme.palette.primary.main}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
    marginRight: 8,
  },
  stepNumberInner: {
    color: theme.palette.primary.main,
  },
  stepInformation: {
    color: theme.palette.primary.dark,
  },
  arrow: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  step1: {
    marginBottom: 19,
    paddingLeft: 17,
    '& $arrow': {
      width: 102,
      height: 'auto',
      transform: 'translate3d(-100%, 15px, 0)',
    },
  },
  step2: {
    position: 'absolute',
    top: 'initial',
    bottom: 0,
    right: '5%',
    transform: 'translate3d(-50%, -40px, 0)',
    '& $arrow': {
      width: 'auto',
      left: 'initial',
      right: 0,
      height: '46px',
      transform: 'translate3d(110%, 6px, 0)',
    },
    '&.active': {
      transform: 'translate3d(-50%, -10px, 0)',
      transition: 'all ease 0.5s 0.4s',
    },
  },
  step3: {
    width: 420,
    position: 'absolute',
    bottom: 0,
    left: '60%',
    transform: 'translate3d(-50%, calc(100% + 70px), 0)',
    '& $arrow': {
      width: 'auto',
      left: 'initial',
      top: '0',
      right: 100,
      height: '94px',
      transform: 'translate3d(25px, -100%, 0)',
    },
    '&.active': {
      transform: 'translate3d(-50%, calc(100% + 20px), 0)',
      transition: 'all ease 0.5s 0.8s',
    },
    '& $stepInformation': {
      maxWidth: 300,
    },
  },
  step4: {
    position: 'initial',
    top: 'initial',
    left: 'initial',
    right: 'initial',
    transform: 'translate3d(0%, 40px, 0)',
    '& $arrow': {
      display: 'none',
    },
    '& $stepInformation': {
      whiteSpace: 'nowrap',
    },
    '&.active': {
      transform: 'translate3d(0%, 0, 0)',
    },
  },
}))

export default useStyles
